<template>
  <modal-container
    v-if="params"
    :isModalActive="activeModal"
    v-on:closeModal="close"
  >
    <div slot="modal-content" class="fh">
      <div class="content-layout fh">
        <div
          class="left-content fh"
          :style="{ flex: params.index === 0 ? 2 : 3 }"
        >
          <div style="margin: 0px 16px 16px;" class="rb shadow">
            <div style="padding: 5px 16px;" class="bold">
              {{ params.chartName }}
            </div>
            <div v-if="activeChart.data">
              <bar-chart
                style="padding: 10px 0; width: 90%; margin: auto; position: relative"
                ref="assessment-progress"
                chart-id="assessment-results-chart"
                :chart-data="activeChart.data"
                :extra-options="activeChart.options"
              >
              </bar-chart>
            </div>
          </div>
          <div
            class="summary-cards"
            :class="params.index === 0 ? 'flex' : 'grid'"
          >
            <small-card
              v-if="params.index === 1"
              :heading="smallCardText.grey"
              color="red"
              :total="smallCardValue[0]"
              :cardIndex="0"
              :activeBtn="activeButton"
              v-on:cardClicked="changeTableData"
            />
            <small-card
              :heading="smallCardText.red"
              color="red"
              :total="smallCardValue[1]"
              :cardIndex="1"
              :activeBtn="activeButton"
              v-on:cardClicked="changeTableData"
            />
            <small-card
              :heading="smallCardText.yellow"
              :total="smallCardValue[2]"
              color="yellow"
              :cardIndex="2"
              :activeBtn="activeButton"
              v-on:cardClicked="changeTableData"
            />
            <small-card
              :heading="smallCardText.green"
              color="green"
              :total="smallCardValue[3]"
              :cardIndex="3"
              :activeBtn="activeButton"
              v-on:cardClicked="changeTableData"
            />
          </div>
        </div>
        <div
          class="right-content fh rb shadow"
          :style="{ flex: params.index === 0 ? 3 : 2 }"
        >
          <div class="modal-table">
            <div class="bold">
              {{
                `Students ${params.index === 0 ? "Progress" : "Results"} in ${
                  active.thread
                }`
              }}
            </div>
            <div class="search-dwnld">
              <search-bar
                :label="''"
                :studentsList="tableData"
                class="navbar-item"
              ></search-bar>
              <div v-if="tableData.length < 0">
                <csv-download
                  :Chart="params.index"
                  :students="tableData"
                  icon="download"
                />
              </div>
            </div>
            <div class="fh" style="width: 100%; position: relative;">
              <learner-table
                :index="params.index"
                v-model="tableData"
                :users="tableData"
                style="height: 100%; padding: 0 0 8rem; box-shadow: inset 0 -20px 20px -20px rgba(50,50,50,0.2);"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal-container>
</template>

<script>
/* eslint-disable prettier/prettier */
import { mapState, mapGetters, mapMutations } from "vuex";
import ModalContainer from "@/modules/global/containers/ModalContainer.vue";
import BarChart from "@/modules/global/lib/charts/BarChart.js";
import assessmentChartDataGeneratorMixin from "@/modules/global/mixins/assessmentChartDataGeneratorMixin.js";
import LearnerTable from "@/modules/global/components/TableComponent.vue";
import SmallStatsModal from "@/modules/global/components/SmallStatModal.vue";
import SearchBar from "@/modules/global/components/SearchbarComponent.vue";
import CSVDownload from "@/modules/global/components/VueXLSXDownloadComponent.vue";
export default {
  name: "ViewAll",
  props: {
    params: { type: Object }
  },
  data() {
    return {
      activeData: null,
      activeButton: -1
    };
  },
  mixins: [assessmentChartDataGeneratorMixin],
  components: {
    "modal-container": ModalContainer,
    "bar-chart": BarChart,
    "learner-table": LearnerTable,
    "small-card": SmallStatsModal,
    "search-bar": SearchBar,
    "csv-download": CSVDownload
  },
  computed: {
    ...mapState({
      activeModal: state => state.globalStore.settings.isViewAllModalActive,
      active: state => state.globalStore.activeFilterParams,
      threadId: state => state.globalStore.activeFilterParams.threadId,
      assessmentType: state =>
        state.globalStore.activeFilterParams.assessmentType
    }),
    ...mapGetters({
      userData: "globalStore/getFilteredList"
    }),
    activeChart() {
      if (this.params.index === 0) {
        return { data: this.pChart.data, options: this.pChart.extraOptions };
      } else if (this.params.index === 1) {
        return { data: this.rChart.data, options: this.rChart.extraOptions };
      }
      return { data: null, options: null };
    },
    tableData() {
      if (this.activeButton === -1) {
        return this.activeData;
      } else if (this.activeButton === 0) {
          return this.resultsLevels()["card0"];
      } else if (this.activeButton === 1) {
        if (this.params.index == 0) {
          return this.progressLevels()["notStarted"];
        }
        return this.resultsLevels()["card1"];
      } else if (this.activeButton === 2) {
        if (this.params.index === 0) {
          return this.progressLevels()["stillDoing"];
        }
        return this.resultsLevels()["card2"];
      } else if (this.activeButton === 3) {
        if (this.params.index === 0) {
          return this.progressLevels()["finished"];
        }
        return this.resultsLevels()["card3"];
      }
      return [];
    },
    smallCardText() {
      if (this.params.index === 0) {
        return {
          red: "Haven't started",
          yellow: "Have started but not completed",
          green: "Completed"
        };
      } else if (this.params.index === 1) {
        return {
          red: `Between Grades ${this.resultsGradeInteval[1][0]} - ${this.resultsGradeInteval[1][1]}`,
          yellow: `Between Grades ${this.resultsGradeInteval[2][0]} - ${this.resultsGradeInteval[2][1]}`,
          green: `Mastered at Grade ${this.resultsGradeInteval[3][0]}`,
          grey: `Below Grade ${this.resultsGradeInteval[0][0]}`
        };
      }
      return {};
    },
    smallCardValue() {
      if (this.params.index === 0) {
        return {
          "1": this.progressLevels()["notStarted"].length,
          "2": this.progressLevels()["stillDoing"].length,
          "3": this.progressLevels()["finished"].length
        };
      } else if (this.params.index === 1) {
        return {
          "0": this.resultsLevels().card0.length,
          "1": this.resultsLevels().card1.length,
          "2": this.resultsLevels().card2.length,
          "3": this.resultsLevels().card3.length
        };
      }
      return {};
    },
    resultsGradeInteval() {
      let intervals = {
        "0": [],
        "1": [],
        "2": [],
        "3": []
      };
      if (this.active.assessmentType === "MATHS_JUNIOR_PRIMARY") {
        intervals["0"].push(1);
        intervals["1"].push(...[1, 1]);
        intervals["2"].push(...[2, 2]);
        intervals["3"].push(3);
      } else if (this.active.assessmentType === "MATHS_SENIOR_PRIMARY") {
        intervals["0"].push(1);
        intervals["1"].push(...[1, 3]);
        intervals["2"].push(...[4, 5]);
        intervals["3"].push(6);
      } else if (this.active.assessmentType === "ENGLISH_JUNIOR_PRIMARY") {
        intervals["0"].push(1);
        intervals["1"].push(...[1, 1]);
        intervals["2"].push(...[2, 2]);
        intervals["3"].push(3);
      } else if (this.active.assessmentType === "ENGLISH_SENIOR_PRIMARY") {
        intervals["0"].push(1);
        intervals["1"].push(...[1, 3]);
        intervals["2"].push(...[4, 5]);
        intervals["3"].push(6);
      } else {
        intervals["0"].push(3);
        intervals["1"].push(...[3, 5]);
        intervals["2"].push(...[6, 8]);
        intervals["3"].push(9);
      }
      return intervals;
    }
  },
  methods: {
    ...mapMutations({
      isModalActive: "globalStore/updateIsViewAllModalActive"
    }),
    close() {
      this.isModalActive(false);
      this.activeButton = -1;
    },
    progressLevels() {
      let notStarted = this.progressArray.filter(user => {
        return (
          user.assessmentStates[0].threads[this.active.threadId].progress === 0
        );
      });

      let stillDoing = this.progressArray.filter(user => {
        return (
          user.assessmentStates[0].threads[this.active.threadId].progress > 0 &&
          user.assessmentStates[0].threads[this.active.threadId].progress < 100
        );
      });

      let finished = this.progressArray.filter(user => {
        return (
          user.assessmentStates[0].threads[this.active.threadId].progress ===
          100
        );
      });
      return { notStarted, stillDoing, finished };
    },
    resultsLevels() {
      let card0 = this.completedAssessmentResults.filter(user => {
        let currentAssessment = user.assessmentStates[0].feedback.find(
          thread => thread.threadId === this.active.threadId + 1
        );
        return currentAssessment.gradeMastered < this.resultsGradeInteval[0][0];
      });
      let card1 = this.completedAssessmentResults.filter(user => {
        let currentAssessment = user.assessmentStates[0].feedback.find(
          thread => thread.threadId === this.active.threadId + 1
        );
        return (
          currentAssessment.gradeMastered >= this.resultsGradeInteval[1][0] &&
          currentAssessment.gradeMastered <= this.resultsGradeInteval[1][1]
        );
      });
      let card2 = this.completedAssessmentResults.filter(user => {
        let currentAssessment = user.assessmentStates[0].feedback.find(
          thread => thread.threadId === this.active.threadId + 1
        );
        return (
          currentAssessment.gradeMastered >= this.resultsGradeInteval[2][0] &&
          currentAssessment.gradeMastered <= this.resultsGradeInteval[2][1]
        );
      });
      let card3 = this.completedAssessmentResults.filter(user => {
        let currentAssessment = user.assessmentStates[0].feedback.find(
          thread => thread.threadId === this.active.threadId + 1
        );
        return (
          currentAssessment.gradeMastered === this.resultsGradeInteval[3][0]
        );
      });
      return { card0, card1, card2, card3 };
    },
    changeTableData(payload) {
      this.activeButton = payload;
    }
  },
  watch: {
    params: {
      handler: function() {
        this.activeData =
          this.params.index === 0
            ? this.progressArray
            : this.completedAssessmentResults;
      }
    }
  }
};
</script>
